"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsActiveLink = void 0;
var react_1 = require("react");
var navigation_1 = require("next/navigation");
var normalizePath = function (path) { return path.replace(/\/$/, ''); };
var stripLanguagePrefix = function (path) {
    var segments = path.split('/');
    if (segments.length > 1 && /^[a-z]{2}(?:-[A-Z]{2})?$/.test(segments[1])) {
        return "/".concat(segments.slice(2).join('/')) || '/';
    }
    return path;
};
var checkIsActiveLink = function (currentPathname, targetPath) {
    var normalizedCurrentPathname = normalizePath(currentPathname);
    var normalizedTargetPath = normalizePath(targetPath);
    var strippedCurrentPathname = stripLanguagePrefix(normalizedCurrentPathname);
    var strippedTargetPath = stripLanguagePrefix(normalizedTargetPath);
    var currentSegments = strippedCurrentPathname.split('/');
    var targetSegments = strippedTargetPath.split('/');
    if (targetSegments.every(function (segment, index) { return currentSegments[index] === segment; })) {
        return (currentSegments.length === targetSegments.length ||
            currentSegments.length > targetSegments.length);
    }
    return false;
};
var useIsActiveLink = function (targetPath) {
    var pathname = (0, navigation_1.usePathname)();
    return (0, react_1.useMemo)(function () {
        return checkIsActiveLink(pathname, targetPath);
    }, [pathname, targetPath]);
};
exports.useIsActiveLink = useIsActiveLink;
